import * as React from "react";
import { formatMoney } from "../../../shared/api/formatutil";
import { CartItem } from "../../interfaces/cart";
import CartDisplayItemProgramClass from "./cartdisplayitemprogramclass";
import CartDisplayItemGeneric from "./cartdisplayitemgeneric";

interface CartDisplayItemProps {
    cartitem: CartItem;
}

const CartDisplayItem = ({ cartitem }: CartDisplayItemProps) => {
    switch (cartitem.itemType) {
        case "programClass":
            // Here, TypeScript knows item is a CartItemProgramClass
            return <CartDisplayItemProgramClass cartitem={cartitem} />;
        default:
            return <CartDisplayItemGeneric cartitem={cartitem} />;
    }
};

export default CartDisplayItem;
